import React from 'react';
import Navigation from '../Navigation';
import Sidebar from './Sidebar';
import './Layout.css';

function Layout({ children }) {
  return (
    <div className="layout">
      <Navigation />
      <div className="layout-container">
        <Sidebar />
        <main className="content-with-sidebar">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;